// No need to import React hooks anymore
// Logic: This function will be called by your home.ts whenever the query changes.

export function renderHomeSearchSuggestions(
  query: string,
  onSelect: (value: string) => void,
  containerElement: HTMLElement | null,
) {
  // 1. Remove existing container if it exists to avoid duplicates
  const existing = document.querySelector(".home-suggestions-container");
  if (existing) existing.remove();

  // 2. "if (!query.trim()) return null;" equivalent
  if (!query.trim()) return;

  // 3. Define the suggestions
  const suggestions = [
    `${query} news`,
    `${query} images`,
    `${query} videos`,
    `${query} wiki`,
    `${query} price`,
  ];

  // 4. Create the container
  const suggestionsContainer = document.createElement("div");
  suggestionsContainer.className = "home-suggestions-container";

  // 5. Create and append the items
  suggestions.forEach((s) => {
    const item = document.createElement("div");
    item.className = "home-suggestion-item";

    // Set internal HTML to match your original structure
    item.innerHTML = `
      <span class="home-suggestion-icon">🔍</span>
      <span class="suggestion-text">${s}</span>
    `;

    // Handle onClick logic
    item.addEventListener("click", () => {
      onSelect(s);
      suggestionsContainer.remove(); // Close after selection
    });

    suggestionsContainer.appendChild(item);
  });

  // 6. Append to the search wrapper in home.ts
  containerElement?.appendChild(suggestionsContainer);
}
